module.exports = __webpack_public_path__ + "img/HC1010-198.dd78c6f6.jpg";